const enCnSite: Partial<Record<string, string>> = {
  'site.meta.keywords':
    'Free Playground, Tutorials, 3D models, 3D programming, 3D Games, Metaverse, Creativity, 3D, Game, Coding, Problem Solving, Design Thinking',
  'WhyBanner.mainTitle': 'Why CreatiCode?',
  'WhyBanner.creativeTitle': 'Compatible with\nStandard Blocks',
  'WhyBanner.creativeContent':
    'Our platform is built upon with standard open-source blocks, with many new features that make you more productive. You will find it very easy to get started.',
  'VideoBannerTop.creativeTitle': 'Enhanced 2D\n Playground',
  'VideoBannerTop.contactTitle': '3D\nPlayground',
  'VideoBannerTop.creative.title': 'Enhanced 2D\nPlayground',
  'VideoBannerTop.contact.title': '3D\nPlayground',
  'VideoBannerTop.creativeCN.title': 'Write 3D programs\nwith blocks',
  'VideoBannerTop.contactCN.title': '3D\n游乐场',
  'VideoBannerTop.focusCN.title': '自学课程',
};

export default enCnSite;
